export default {
  title: "計算歷史",
  type: "類型",
  routeSearch: "路線搜尋",
  batchId: "批次 ID",
  createdAt: "建立時間",
  totalDistance: "總距離 (km)",
  productionEmission: "生產排放 (kg CO2e)",
  transportEmission: "運輸排放 (kg CO2e)",
  totalEmission: "總排放 (kg CO2e)",
  taxInEUR: "稅費 (€)",
  action: "操作",
  detail: "詳情",
  deleteConfirm: "確定要刪除此記錄嗎？",
  data: "數據",
  reports: "報告",
  batchDownload: "批次下載",
  batchDownloadPdf: "PDF 批次下載",
  batchDownloadExcel: "Excel 批次下載",
  selectPlaceholder: "請至少選擇一個記錄",
  quotaInsufficient: "配額不足，請升級或購買",
  batchDownloadSuccess: "批次下載完成，選擇已重置",
  batchDownloadFailed: "批次下載失敗",
  emptyFile: "產生的檔案為空",
  downloadProgress: "下載進度",
  completed: "已完成",
  but: "但是",
  regenerate: "重新生成",
};
